<div class="d-flex align-items-center py-3 py-md-1">
    <div class="container" id="fullPage">
        <div class="card login-card">
            <div class="row justify-content-center">
                <!-- <div class="col-md-5 d-none d-md-block align-self-center" style="border-right: 2px solid lightgray;">
                    <img src="assets/img/batteries.png" alt="login" class="login-card-img ml-5">
                </div> -->
                <div class="col-12 mt-4 pb-0 mb-0 ms-5">
                  <button class="arrowBtn btn btn-sm btn-outline-dark" (click)="goLogin()">
                    <i class="bi bi-arrow-left"></i>
                  </button>
                </div>
                <div class="col-12 text-center">
                    <div class="card-body pt-0">
                        <div class="brand-wrapper">
                            <img src="assets/img/logo.png" alt="logo" class="logo">
                        </div>
                        <p class="login-card-description">{{"PROFILE.SENDEMAILPSW.RECOVER" | translate}}</p>
                        <p style="font-size: x-small; margin-bottom: 23px;">{{"PROFILE.SENDEMAILPSW.EMAILMESSAGE" | translate}}</p>
                        <div class="col-12">
                            <form [formGroup]="recoverPswForm" class="has-validation" style="margin: 0 auto;">
                                <div class="form-group">
                                    <label for="email" class="sr-only">{{"PROFILE.SENDEMAILPSW.EMAIL" | translate}}</label>
                                    <input type="email" name="email" id="email" formControlName="email"
                                        class="form-control" placeholder="{{'PROFILE.SENDEMAILPSW.PLACEHOLDEREMAIL' | translate}}"
                                        [ngClass]="{'error': !validEmail}" aria-describedby="emailFeedback" required (input)="checkEmail()">
                                    <div *ngIf="!validEmail" id="email" class="mt-2" style="color: rgb(255, 0, 0);">
                                        <small>{{"PROFILE.SENDEMAILPSW.ERROR" | translate}}</small>
                                    </div>
                                </div>
                                <input name="send" id="send" class="btn btn-block send-btn mb-4 mt-2" type="button"
                                    value="Send" (click)="send()">
                                <div *ngIf="isSent" class="mb-1" id="email">
                                    <span style="font-size: medium;">{{"PROFILE.SENDEMAILPSW.RESPONSEMESSAGE" | translate}}</span>
                                </div>
                            </form>
                        </div>
                        <nav class="login-card-footer-nav">
                            <a href="https://www.iubenda.com/privacy-policy/78584924" target="_blank"
                                class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe me-4"
                                title="Privacy Policy ">Privacy Policy</a>
                            <script
                                type="text/javascript">(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);</script>
                            <a href="https://www.iubenda.com/terms-and-conditions/78584924" target="_blank"
                                class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe "
                                title="Terms and Conditions ">Terms and Conditions</a>
                            <script
                                type="text/javascript">(function (w, d) { var loader = function () { var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src = "https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s, tag); }; if (w.addEventListener) { w.addEventListener("load", loader, false); } else if (w.attachEvent) { w.attachEvent("onload", loader); } else { w.onload = loader; } })(window, document);</script>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
